// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"OY-z","sponsoredTooltipWrapper":"PY-z","sponsoredTooltip":"QY-z","newCard":"RY-z"};